import { kebabCase } from 'lodash-es';

/**
 * Derives a slash-command slug from a workflow or skill name.
 *
 * @example toSkillSlug('Morning roster prep') => 'morning-roster-prep'
 * @example toSkillSlug('AccuroReschedulePatient') => 'accuro-reschedule-patient'
 */
export function toSkillSlug(name: string): string {
  return kebabCase(name);
}
